import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Modal } from "newcar-ui/output/cjs/components/AskpricePublicModal";
import { TelRow } from "newcar-ui/output/cjs/components/InputRow";
import {
  setCookie,
  getCookie,
  addHandler,
} from "newcar-ui/output/cjs/utils/tools";
import { sendClickStatistics_wmda } from "newcar-ui/output/cjs/utils/wmdaTracklog";
import { isMobile } from "newcar-ui/output/cjs/utils/form";
import { Prompt } from "newcar-ui/output/cjs/components/Prompt";
import { request } from "newcar-ui/output/cjs/utils/request";
// import Bus from "../eventBus";
import "./style.scss";
let submitFlag = false;
let LeavePop = forwardRef((props, ref) => {
  useImperativeHandle(
    ref,
    () => {
      return {
        showLeavePop: () => {
          // 显示回退弹窗
          listenReturn();
        },
      };
    },
    [props]
  );
  const { productId, lineId, cityId } = props;
  const [leavePopShow, setleavePopShow] = useState(false);
  const [leavePopTel, setLeavePopTel] = useState(
    getCookie("askPricePhone") || ""
  );
  const [errorTip, setErrorTip] = useState("");
  const [errorTipShow, setErrorTipShow] = useState(false);
  const listened = useRef(false);
  const listenReturn = useCallback(() => {
    // 监听页面回退事件
    if (listened.current || !lineId) {
      return;
    }
    /**
     * 场景一：
     * 打开页面时，没有submit   点击页面任意地方后， 返回  显示leavePop   关闭leavePop回到上一页
     *
     * 场景二：
     * 打开页面是，没有sutmit，提交bottomPop， 返回  回到上一页
     *
     * 场景三：
     * 打开页面，sbumit   返回  回到上一页
     */
    window.addEventListener(
      "popstate",
      function (event) {
        listened.current = true;
        if (
          !getCookie(`picAskpricePopFromLeave_${lineId}`) &&
          !getCookie(`picAskpricePopFormBottom_${lineId}`)
        ) {
          event.preventDefault();
          openPop();
        }
        // else if (window.sessionStorage.getItem("pushstated")) {
        //   event.preventDefault();
        //   console.log("退两页", window.history.length);
        //   window.sessionStorage.removeItem("pushstated");
        //   window.history.go(-1)
        // } else {
        //   console.log("退一页");
        //   window.history.go(-1)
        // }
        else {
          event.preventDefault();
          window.sessionStorage.removeItem("pushstated");
          window.history.go(-1);
        }
      },
      false
    );
    if (
      !getCookie(`picAskpricePopFromLeave_${lineId}`) &&
      !getCookie(`picAskpricePopFormBottom_${lineId}`)
      // && !window.sessionStorage.getItem("pushstated")
    ) {
      const state = {
        title: document.getElementsByTagName("title")[0].innerText,
        url: "#",
      };
      // window.sessionStorage.setItem("pushstated", 1);
      window.history.pushState(state, "title", "#");
    }
  }, []);
  const openPop = useCallback(() => {
    //  window.sessionStorage.removeItem("pushstated");
    setleavePopShow(true);
    // Bus.emit("hideAskpricePopFromBottom", true);
  }, []);
  useEffect(() => {
    const pageReturnBtn = document.querySelector("#resturn");
    if (pageReturnBtn) {
      addHandler(pageReturnBtn, "click", (event) => {
        if (
          !getCookie(`picAskpricePopFromLeave_${lineId}`) &&
          !getCookie(`picAskpricePopFormBottom_${lineId}`)
        ) {
          event.preventDefault();
          openPop();
        }
      });
    }
  }, []);
  useEffect(() => {
    if (leavePopShow) {
      sendClickStatistics_wmda(288, {
        pagetype: "prd",
        page: "line-pic-view",
        platform: "m",
        cate_lv1: "prd",
        cate_lv2: "line",
        cate_lv3: "pic-detail",
      });
      setCookie({
        name: `picAskpricePopFromLeave_${lineId}`,
        value: 1,
        expiredays: 1,
      });
    }
  }, [leavePopShow]);
  const onInputLeavePopInput = useCallback((val) => {
    setLeavePopTel(val);
  }, []);
  const onSubmitLeavePop = useCallback(() => {
    if (submitFlag) {
      return;
    }
    if (!isMobile(leavePopTel)) {
      showPrompt("请输入正确的手机号码！");
      return;
    }
    submitFlag = true;
    request(
      "//service.58che.com/unify/v1/suborder/",
      {
        uuid: getCookie("58tj_uuid"),
        productId: productId,
        lineId: lineId,
        phone: leavePopTel,
        f: 548,
        fromCode: window.getFrom(),
        cityId: cityId,
        platform: "m",
        checkType: 0,
      },
      "json",
      { method: "post", isCors: true, paramsType: "formdata" }
    )
      .then((resp) => {
        submitFlag = false;
        if (resp.code == 0) {
          showPrompt("提交成功，稍后4S店顾问和您联系");
          setCookie({
            name: `picAskpricePopFromLeave_askpriceed_${lineId}`,
            value: 1,
            expiredays: 1,
          });
          setTimeout(() => {
            setleavePopShow(false);
            window.history.back();
          }, 2000);
        } else {
          throw resp;
        }
      })
      .catch((err) => {
        submitFlag = false;
        showPrompt(err.message || err.msg || "提交失败，未知错误");
      });
  }, [leavePopTel, cityId]);
  const showPrompt = useCallback((str) => {
    setErrorTip(str);
    setErrorTipShow(true);
  }, []);
  const hidePop = useCallback(() => {
    setleavePopShow(false);
    sendClickStatistics_wmda(289, {
      pagetype: "prd",
      page: "line-pic-view",
      platform: "m",
      cate_lv1: "prd",
      cate_lv2: "line",
      cate_lv3: "pic-detail",
    });
    setTimeout(() => {
      window.history.back();
    }, [300]);
  }, []);
  return (
    <>
      <Modal
        visible={leavePopShow}
        direction="center"
        needAnimation={false}
        allowMaskCloseFn={hidePop}
        cn="leavePop"
      >
        <div className="leavePopCon">
          <a className="leavePopCloseBtn" onClick={hidePop}></a>
          <h4 className="leavePopMainTitle">喜欢这款车么？</h4>
          <p className="leavePopSubTitle">
            快速获取4s店的车型最低价格，快来试试
          </p>
          <TelRow
            inputFun={onInputLeavePopInput}
            labelStr="电话"
            cn="leavePopInputWrap"
            defaultValObj={{
              encrptionVal: getCookie("askPricePhone") || "",
            }}
          ></TelRow>
          <a className="leavePopSubmitBtn" onClick={onSubmitLeavePop}>
            好的
          </a>
          <p className="leavePopProtocol">
            提交即代表您已阅读并同意
            <a href="//appsm.58che.com/58/authorizebook.html">
              《个人信息授权书及保护声明》
            </a>
          </p>
        </div>
      </Modal>
      <Prompt
        show={errorTipShow}
        tipStr={errorTip}
        cn="askpricePopFromLeave_errorTip"
        closeFun={() => {
          setErrorTipShow(false);
        }}
      ></Prompt>
    </>
  );
});
LeavePop.defaultProps = {
  productId: "",
  lineId: "",
  cityId: "",
};
export default LeavePop;
